// extracted by mini-css-extract-plugin
export default {"categoryWrapper":"category_categoryWrapper__FSsm+","category":"category_category__evSFg","hiddenInput":"category_hiddenInput__IyOhl"};